import React, { useEffect } from "react";
import Page_Header from "../General/Page_Header";
import "./Main.css";
import { useSelector } from "react-redux";
import {
  loadStatisticTarget,
  loadDashboardLayout,
} from "../../Redux/Actions/ActionStatistics";
import StatisticsWorkPlans from "./Statistics/StatisticsWorkPlans";
import ChartComponent from "../WorkPlans/VisitesWorkPlan/ChartComponent";
import { AbstructVar } from "../General/GeneralComponent/AbstructVar";
import { AbstructLang } from "../General/GeneralComponent/AbstructLang";
import Page_General_Statistics from "./CardsMain/Page_General_Statistics";
import Scientific_Office_Statistics from "./CardsMain/Scientific_Office_Statistics";
import FilterStatistics from "./Statistics/FilterStatistics";
import SmartCardsPanel from "../GeneralReports/SmartCardsPanel";
import ScheduledReports from "../GeneralReports/ScheduledReports";

/**
 * FE-12 — Dashboard Builder consumer.
 * Widget order for the main dashboard. When the user has no saved layout,
 * keep the legacy section order (conservative default).
 */
const MAIN_DEFAULT_WIDGETS = [
  "general_statistics",
  "scientific_office",
  "work_plan_stats",
  "target_group_report",
];

function Main({ isDashboardPage }) {
  let { langmiamed, dispatch, navigate } = AbstructVar();
  const { translate } = AbstructLang();
  const statisticsTarget = useSelector(
    (state) => state.statisticss.statisticsTarget
  );
  const dashboardLayout = useSelector(
    (state) => state.statisticss.dashboardLayout
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(loadStatisticTarget());
    dispatch(loadDashboardLayout());
  }, []);

  /* Hand-off from dashboard smart cards to the reports page */
  const handleSmartCardSelect = (reportKey) => {
    try {
      localStorage.setItem("miamed_pending_report", reportKey);
    } catch {}
    navigate("/reports");
  };

  /* Saved layout wins; fall back to the legacy order */
  const layoutWidgets = dashboardLayout?.widgets?.length
    ? dashboardLayout.widgets.filter((w) => w && w.key)
    : MAIN_DEFAULT_WIDGETS.map((key) => ({ key, visible: true }));

  const renderWidget = (key) => {
    switch (key) {
      case "general_statistics":
        if (!isDashboardPage) return null;
        return (
          <>
            <h4
              className={`workplanrepo ${
                langmiamed == "ar" ? "textRight" : ""
              }`}
            >
              {translate("General_statistics")}
            </h4>
            <Page_General_Statistics
              langmiamed={langmiamed}
              dispatch={dispatch}
              translate={translate}
            />
          </>
        );
      case "scientific_office":
        if (!isDashboardPage) return null;
        return (
          <>
            <h4
              className={`workplanrepo ${
                langmiamed == "ar" ? "textRight" : ""
              }`}
            >
              {translate("Scientific_Office")}
            </h4>
            {/* <FilterStatistics
              t={translate}
              langmiamed={langmiamed}
              params="external_visit"
            /> */}
            <Scientific_Office_Statistics
              t={translate}
              langmiamed={langmiamed}
              dispatch={dispatch}
            />
          </>
        );
      case "work_plan_stats":
        return (
          <div>
            <StatisticsWorkPlans t={translate} langmiamed={langmiamed} />
          </div>
        );
      case "target_group_report":
        return (
          <>
            <h4
              className={`workplanrepo ${
                langmiamed == "ar" ? "textRight" : ""
              }`}
            >
              {translate("target_group_report")}
            </h4>
            {/* <FilterStatistics
              t={translate}
              langmiamed={langmiamed}
              params="target_type"
            /> */}
            <div
              className="div_static_target"
              dir={langmiamed == "ar" ? "rtl" : "ltr"}
            >
              <div className="div_static_target_card">
                <div
                  className={`one_bottom_analytics1 ${
                    langmiamed === "ar" ? "margin_left_30" : "margin_right_30"
                  } `}
                >
                  <span>{translate("visitesCount")}</span>
                  <span className="alltaskscount">
                    {statisticsTarget.visits_count}
                  </span>
                </div>
                <div
                  className={`one_bottom_analytics1 ${
                    langmiamed === "ar" ? "margin_left_30" : "margin_right_30"
                  } `}
                >
                  <span>{translate("delivered")}</span>
                  <span className="alltaskscount">
                    {statisticsTarget.delivered_product_count}
                  </span>
                </div>
              </div>
              <div className="div_static_target_chart">
                <div className="onechart" style={{ width: "100%" }}>
                  <ChartComponent
                    langmiamed={langmiamed}
                    color1="#50b798"
                    num1={statisticsTarget.marketing_tools_count}
                    num2={statisticsTarget.medicine_samples_count}
                    name1={translate("marketing_tools_count")}
                    name2={translate("medicine_samples_count")}
                  />
                </div>
              </div>
            </div>
          </>
        );
      case "recent_reports":
        return (
          <div className="main-widget-panel">
            <SmartCardsPanel
              mode="recent"
              onSelect={handleSmartCardSelect}
              activeReport={null}
              translate={translate}
            />
          </div>
        );
      case "favorites":
        return (
          <div className="main-widget-panel">
            <SmartCardsPanel
              mode="favorites"
              onSelect={handleSmartCardSelect}
              activeReport={null}
              translate={translate}
            />
          </div>
        );
      case "scheduled_reports":
        return (
          <div className="main-widget-panel">
            <ScheduledReports translate={translate} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={langmiamed == "ar" ? "main-content_ar" : "main-content_en"}>
      <main>
        {isDashboardPage && (
          <Page_Header
            langmiamed={langmiamed}
            header={translate("dashboard")}
            path={`${translate("home")} / ${translate("dashboard")} `}
          />
        )}

        <div
          style={{
            padding: "1.3rem 1rem", // corrected syntax for padding
            background: "white",
            margin: isDashboardPage ? "-35px 60px 20px 60px" : "0",
            borderRadius: "30px", // corrected syntax for borderRadius
            minHeight: "90vh", // corrected syntax for minHeight
            /*overflow: auto;*/
            position: "relative", // corrected syntax for position
          }}
        >
          {layoutWidgets.map((w) =>
            w.visible === false ? null : (
              <React.Fragment key={w.key}>
                {renderWidget(w.key)}
              </React.Fragment>
            )
          )}
        </div>
      </main>
    </div>
  );
}

export default Main;
